import * as T from './ImageProxy.types';

export const urlSafeBase64 = (string: string): string =>
  Buffer.from(string)
    .toString('base64')
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');

export const buildImgProxyUrl = (
  resizingType: T.ImageProxyProps['resizingType'],
  width: number,
  height: number,
  enlarge: number,
  gravityType: T.ImageProxyProps['gravityType'],
  quality: number,
  src: string,
  extension?: T.ImageProxyProps['extension']
): string => {
  const host = process.env.NEXT_PUBLIC_CDN_HOST as string;
  const encodedUrl = urlSafeBase64(src);

  return `${host}/insecure/rs:${resizingType}:${width}:${height}:${enlarge}/g:${gravityType}/q:${quality}/${encodedUrl}.${
    extension || 'webp'
  }`;
};
